import { cn } from "@/lib/utils";

function initials(name: string) {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
}

export function EmployeeAvatar({
  name,
  photoUrl,
  className,
}: {
  name: string;
  photoUrl?: string | null;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-center overflow-hidden rounded-full bg-accent text-accent-foreground",
        className,
      )}
    >
      {photoUrl ? (
        <img src={photoUrl} alt={name} className="size-full object-cover" />
      ) : (
        <span className="text-[0.4em] font-semibold tracking-wide">{initials(name)}</span>
      )}
    </div>
  );
}
